// Auto-generated by @fermata/grpc-zustand - DO NOT EDIT
// Generated from: @proto/gen/users/v1/service.client

import { getDefaultTransport } from "@fermata/grpc-zustand/runtime"
import { CustomerServiceClient } from "@proto/gen/users/v1/service.client"
import type { RpcTransport } from "@protobuf-ts/runtime-rpc"

/**
 * Lazily constructed CustomerServiceClient using the current default transport.
 *
 * Why lazy?
 * Generated clients are imported very early in app startup; a lazy getter ensures
 * auth/config code can replace the default transport before the first call.
 */
let _transport: RpcTransport | undefined
let _client: CustomerServiceClient | undefined

export function getCustomerClient(): CustomerServiceClient {
  const transport = getDefaultTransport()
  if (!_client || transport !== _transport) {
    _transport = transport
    _client = new CustomerServiceClient(transport)
  }
  return _client
}
